import React from 'react'
import "../MensData.js/ProductsShirts.css";
import menShirt from "../assets/shirt3.jpg"

export default function ProductsHoodies() {

    const productsHoodie = [
  {
    id: 1,
    name: "Model No.MG-25725-18",
    description: "Premium , Modern fit",
    image: menShirt,
    link: "/products/mens-shirt",
  },
  
];
  return (
    <>
       <section className="ps">
      <h1 style={{textAlign:"center",fontSize:"42px"}}>Men’s Shirt</h1>
      <div className="ps__grid">
        {productsHoodie.map((p) => (
          <article key={p.id} className="ps__card">
            <img className="ps__image" src={p.image} alt={p.name} loading="lazy" />
            <h3 className="ps__name">{p.name}</h3>
            <p className="ps__desc">{p.description}</p>
            <a className="ps__btn" href={p.link} aria-label={`View ${p.name}`}>
             Explore More
            </a>
          </article>
        ))}
      </div>
    </section>

    </>
  )
}
